<template>
  <v-container
    id="download"
    tag="section"
  >
    <v-row dense>
      <v-col
        md="6"
        v-for="card in cards"
        :key="card.title"
        :cols="card.flex"
      >
        <v-card
          class="mx-auto"
        >
          <v-img
            class="white--text align-end"
            height="300px"
            :src="card.src"
          >
<!--            <v-card-title v-text="card.title"></v-card-title>-->
          </v-img>

<!--          <v-card-subtitle class="pb-0">-->
<!--            Number 10-->
<!--          </v-card-subtitle>-->

<!--          <v-card-text class="text&#45;&#45;primary">-->
<!--            <router-link-->
<!--              color="orange"-->
<!--              text-->
<!--              :to="`/downloadlist?file_type=${card.file_type}`"-->
<!--            >-->
<!--            <div>{{ card.title }}</div>-->
<!--            </router-link>-->
<!--          </v-card-text>-->

          <v-card-actions>
            <a @click="goDownloadList(card.file_type)">
              <div>{{ card.title }}</div>
            </a>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {mapState} from "vuex";
  import {isMobile} from '../utils/globalUtils'

  export default {
    name: 'download',

    computed: {
      ...mapState({
        isLogin: state => state.user.isLogin
      })
    },

    data() {
      return {
        cards: [
          {
            title: this.$t('download.product_catalogue'),
            src: require('@/assets/download/product_manual.jpeg'),
            file_type: 'product_manual',
            flex: isMobile() ? 12 : 6
          },
          {
            title: this.$t('download.video'),
            src: require('@/assets/download/Video.jpg'),
            file_type: 'video',
            flex: isMobile() ? 12 : 6
          },
          {
            title: this.$t('download.training_materials'),
            src: require('@/assets/download/Training_Materials.jpg'),
            file_type: 'ppt',
            flex: isMobile() ? 12 : 6
          },
          {
            title: this.$t('download.news'),
            src: require('@/assets/download/Newsroom.jpg'),
            file_type: 'news',
            flex: isMobile() ? 12 : 6
          },
        ],
      }
    },

    methods: {
      goDownloadList($fileType) {
        let vm = this;

        if (!vm.isLogin && ['product_manual', 'ppt'].includes($fileType)) {
          vm.$store.commit("open_login_dialog");
        } else {
          // window.location.href = `/product/?product=${productId}`
          vm.$router.push({ path: '/downloadlist', query:{file_type: $fileType} });
        }
      }
    },
  }
</script>
